import React, { useContext } from 'react';
import { IDishAssignmentContext, DishAssignmentContext } from '../../dishAssignmentState/dishAssignmentContext';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { resetChanges, sendChanges, updateModuleDataAfterSaving, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IDishAssignmentContext>(DishAssignmentContext);

	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={resetChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={sendChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSendChanges'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={updateModuleDataAfterSaving}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
